/* FollicGen buy-box tweaks, applied before follicgen.js wires up the buy box:
   1) reference ("antes") price = 69
   2) show prices in euros (the buy-box script outputs "$")
   3) tabular (fixed-width) figures + right alignment so prices line up
   4) wire each plan to its real subscription selling plan + variant, by cadence,
      and pin the per-month subscribe price to a true 20% off the one-time price:
        1 mes  -> every month   | SP 713140535683 | sub EUR 40/mo
        2 meses-> every 2 months| SP 713140568451 | sub EUR 28/mo
        4 meses-> every 4 months| SP 713384362371 | sub EUR 18/mo */
(function () {
  var EUR = '\u20AC';
  var PLANS = {
    '1': { sp: '713140535683', v: '62142961877379', sub: '40' },
    '2': { sp: '713140568451', v: '62142961910147', sub: '28' },
    '6': { sp: '713384362371', v: '62142961942915', sub: '12' }
  };
  var CSS =
    '#fg-buybox .bundle__price{text-align:right;font-variant-numeric:tabular-nums;font-feature-settings:"tnum" 1}' +
    '#fg-buybox .bundle__price .pm,#fg-buybox .bundle__price .was{display:block;font-variant-numeric:tabular-nums;font-feature-settings:"tnum" 1}';
  function injectCss() {
    if (document.getElementById('fg-buybox-css')) return;
    var st = document.createElement('style');
    st.id = 'fg-buybox-css';
    st.textContent = CSS;
    (document.head || document.documentElement).appendChild(st);
  }
  function setBase() {
    var b = document.getElementById('fg-buybox');
    if (b) { b.setAttribute('data-base', '69'); }
  }
  function wirePlans() {
    var bundles = document.querySelectorAll('#fg-buybox .bundle');
    for (var i = 0; i < bundles.length; i++) {
      var b = bundles[i];
      var p = PLANS[b.getAttribute('data-months')];
      if (p) {
        b.setAttribute('data-selling-plan-id', p.sp);
        b.setAttribute('data-variant-id', p.v);
        b.setAttribute('data-sub', p.sub);
      }
    }
  }
  var SEL = '#fg-buybox [data-pm],#fg-buybox [data-was],#fg-buybox [data-total-amt],#fg-buybox [data-save-lbl],[data-offer-now],[data-price-month],.header__price,.mobile-atc__price,.ci-p,[data-cart-total]';
  function eurofy() {
    var els = document.querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.innerHTML.indexOf('$') > -1) { el.innerHTML = el.innerHTML.split('$').join(EUR); }
    }
  }
  function swap() {
    var reps = [['dos veces por semana', 'tres veces por semana'], ['Dos veces por semana', 'Tres veces por semana'], ['dos sesiones cortas por semana', 'tres sesiones cortas por semana'], ['twice a week', '3 times a week'], ['Twice a week', '3 times a week']];
    var root = document.body || document.documentElement; if (!root) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var n, ns = [];
    while ((n = w.nextNode())) ns.push(n);
    for (var i = 0; i < ns.length; i++) {
      var t = ns[i], v = t.nodeValue, c = false;
      for (var j = 0; j < reps.length; j++) { if (v.indexOf(reps[j][0]) > -1) { v = v.split(reps[j][0]).join(reps[j][1]); c = true; } }
      if (c) t.nodeValue = v;
    }
  }
  function start() {
    injectCss();
    setBase();
    wirePlans();
    eurofy();
    swap();
    setTimeout(swap, 300);
    setTimeout(swap, 800);
    if (window.MutationObserver) {
      new MutationObserver(eurofy).observe(document.body || document.documentElement, { subtree: true, childList: true, characterData: true });
    }
  }
  start();
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); }
})();
